import ModalForm from "../../components/Form/ModalForm"
import Footer from "../../components/Footer/Footer"
import Card from "../../components/Card/Card"

import './Partners.css'

export default function Partners() {
    return (
        <main className="partners">
            <div className="partners__content">
                <div className="partners__text">
                    <h2>Наши партнеры</h2>
                    <p> Мы только открылись и очень ждем клиентов </p>
                    <p>
                        Мы приглашаем к <span>сотрудничеству</span> всех,
                        кто хочет вместе с нами <span>развивать свой бизнес</span>,
                        используя <span>понятные</span>, <span>отечественные</span> инструменты,
                        созданные нашими руками под чутким руководством Заказчика.
                        Это будет <span>взаимовыгодное</span> и <span>долгосрочное сотрудничество</span>.

                    </p>
                    <p>
                        Напишите нам! Давайте расти вместе!
                    </p>
                </div>
                <div className="partners__card">
                    <Card
                        title="Р7-Офис"
                        src={"https://optim.tildacdn.com/tild3533-3963-4738-b561-363531663165/-/resize/240x/-/format/webp/Logo_R7-Office.png.webp"}
                        text="// Офисное ПО для документов, таблиц и совместной работы."
                        link="https://r7-office.ru/"
                    />
                    <Card
                        title="МойОфис"
                        src={"https://static.tildacdn.com/tild6531-3430-4237-b862-313839653965/MyOffice_logo_Horizo.svg"}
                        text="// Отечественные офисные приложения и облачные сервисы для бизнеса."
                        link="https://myoffice.ru"
                    />
                    <Card
                        title="Касперский"
                        src={"https://optim.tildacdn.com/tild3238-3631-4066-b334-326666386565/-/resize/310x/-/format/webp/image.png.webp"}
                        text="// Решения для кибербезопасности и защиты данных и инфраструктуры."
                        link="https://www.kaspersky.ru"
                    />
                </div>
                <ModalForm />

            </div>

            <Footer />
        </main>
    )
}
